import 'core-js/es';
import 'raf/polyfill';
import 'core-js/actual/promise';
import 'core-js/features/promise';
import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';

import React from 'react';
import ReactDOM from 'react-dom';
import './index.scss';
import { App } from './App';
import { Provider } from 'react-redux';
import { store } from './redux/redux-toolkit-store';
import * as Sentry from '@sentry/react';
import { BrowserTracing } from '@sentry/tracing';

Sentry.init({
  dsn: "https://e1299ede483e4e84940401d0bfda03f7@o394454.ingest.sentry.io/5579986",
  integrations: [new BrowserTracing()],
  tracesSampleRate: 1.0,
  maxValueLength: 1000
});

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  </React.StrictMode>,
  document.getElementById('root')
);